import API from "../API";

export default API;

export const set = data => {
    return { type: "SET", payload: data };
};

export const logout = () => {
    localStorage.setItem("token", "");
};

export const setTherapist = therapist => {
    return new Promise(function (resolve, reject) {
        API.setTherapist(therapist).then(
            () => {
                resolve({ type: "SET", payload: { therapist: therapist } });
                if (window.profilSaved) window.profilSaved.showAlertSuccess();
            },
            err => {
                console.log(err);
                if (window.profilSaved) window.profilSaved.showAlertError();
            }
        );
    });
};

export const getClientsFromTherapist = () => {
    return new Promise(function (resolve, reject) {
        API.getClientsFromTherapist().then(
            clients => {
                resolve({ type: "SET", payload: { clients: clients } });
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getClientsByEmailFromTherapist = (email) => {
    return new Promise(function (resolve, reject) {
        API.getClientsByEmailFromTherapist(email).then(
            clients => {
                resolve({ type: "SET", payload: { clients: clients } });
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getJournalsFromClient = id => {
    return new Promise(function (resolve, reject) {
        API.getJournalsFromClient(id).then(
            journals => {
                resolve({ type: "SET", payload: { journals: journals } });
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const setClient = (client, t) => {
    return new Promise(function (resolve, reject) {
        if (client.children === "") client.children = null;
        API.setClient(client).then(
            () => {
                if (t) {
                    window.clientDataSaved.showAlertSuccess();
                    resolve({ type: "SET", payload: { client: client } });
                } else resolve({ type: "SET", payload: { client: client } });
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const deleteClient = id => {
    return new Promise(function (resolve, reject) {
        API.deleteClient(id).then(
            () => {
                window.clientDataSaved.showDeleteSuccess();
                resolve();
            },
            err => {
                console.log(err);
                window.clientDataSaved.showDeleteError();
            }
        );
    });
};

export const deleteBooking = id => {
    return new Promise(function (resolve, reject) {
        API.deleteBooking(id).then(
            () => {
                resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const setJournal = (journal, t) => {
    return new Promise(function (resolve, reject) {
        API.setJournal(journal).then(
            () => {
                if (t) {
                    window.clientDataSaved.showAlertSuccess();
                    resolve();
                } else resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const setFieldComment = (comment) => {
    return new Promise(function (resolve, reject) {
        API.setFieldComment(comment).then(
            (dt) => {
                console.log('setFieldComment success', dt);
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getBookingsFromTherapist = (from, to) => {
    return new Promise(function (resolve, reject) {
        API.getBookingsFromTherapist(from, to).then(
            data => {
                resolve(data);
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const addBooking = booking => {
    return new Promise(function (resolve, reject) {
        API.addBooking(booking).then(
            data => {
                console.log(booking);
                resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const setBooking = booking => {
    return new Promise(function (resolve, reject) {
        API.setBooking(booking).then(
            data => {
                resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getTreatmentsFromTherapist = () => {
    return new Promise(function (resolve, reject) {
        API.getTreatmentsFromTherapist().then(
            treatments => {
                resolve({ type: "SET", payload: { treatments: treatments } });
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getBooking = id => {
    return new Promise(function (resolve, reject) {
        API.getBooking(id).then(
            booking => {
                resolve({ type: "SET", payload: { booking: booking } });
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getTreatment = id => {
    return new Promise(function (resolve, reject) {
        API.getTreatment(id).then(
            treatment => {
                resolve({ type: "SET", payload: { treatment: treatment } });
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const addTreatment = treatment => {
    return new Promise(function (resolve, reject) {
        API.addTreatment(treatment).then(
            data => {
                // window.clientDataSaved.showAlertSuccess();
                resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const setTreatment = treatment => {
    return new Promise(function (resolve, reject) {
        API.setTreatment(treatment).then(
            data => {
                // window.clientDataSaved.showAlertSuccess();
                resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const deleteTreatment = id => {
    return new Promise(function (resolve, reject) {
        API.deleteTreatment(id).then(
            () => {
                resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getClient = id => {
    return new Promise(function (resolve, reject) {
        API.getClient(id).then(
            data => {
                resolve(data);
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const addJournal = journal => {
    return new Promise(function (resolve, reject) {
        API.addJournal(journal).then(
            data => {
                console.log(2);
                resolve(data);
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getCustomFieldsFromClientIsNotJournal = id => {
    return new Promise(function (resolve, reject) {
        API.getCustomFieldsFromClientIsNotJournal(id).then(
            stamJournal => {
                resolve({ type: "SET", payload: { stamJournal: stamJournal } });
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const getBookingsFromClient = id => {
    return new Promise(function (resolve, reject) {
        API.getBookingsFromClient(id).then(
            bookings => {
                resolve(bookings);
            },
            err => { }
        );
    });
};

export const setCustomFields = (id, fields, t) => {
    return new Promise(function (resolve, reject) {
        API.setCustomFields(id, fields).then(
            data => {
                if (t) {
                    window.clientDataSaved.showAlertSuccess();
                    resolve();
                } else resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const registerInvoice = customerHandle => {
    return new Promise(function (resolve, reject) {
        API.registerInvoice(customerHandle).then(
            data => {
                resolve();
            },
            err => {
                console.log(err);
            }
        );
    });
};

export const incrementStorageUsedByTherapistInBytes = async (therapistId, bytesUsed) => {
    try {
        return await new Promise(function (resolve, reject) {
            API.incrementStorageUsedByTherapistInBytes(therapistId, bytesUsed).then(
                data => {
                    resolve();
                },
                err => {
                    console.log(err);
                }
            );
        });
    } catch (error) {
        console.error("Error incrementStorageUsedByTherapistInBytes:", error);
    }
};

export const decrementStorageUsedByTherapistInBytes = async (therapistId, bytesFree) => {
    try {
        return await new Promise(function (resolve, reject) {
            API.decrementStorageUsedByTherapistInBytes(therapistId, bytesFree).then(
                data => {
                    resolve();
                },
                err => {
                    console.log(err);
                }
            );
        });
    } catch (error) {
        console.error("Error decrementStorageUsedByTherapistInBytes:", error);
    }
};

export const getTherapistAzureContainer = async (therapistId) => {
    try {
        return await new Promise(function (resolve, reject) {
            API.getTherapistAzureContainer(therapistId).then(
                data => {
                    resolve(data);
                },
                err => {
                    console.log(err);
                }
            );
        });
    } catch (error) {
        console.error("Error getTherapistAzureContainer:", error);
    }
};

export const getAzureStorageSASToken = async (containerName, localStorageKey) => {
    try {
        return await new Promise(function (resolve, reject) {
            API.getAzureStorageSASToken(containerName).then(
                data => {
                    localStorage.setItem(localStorageKey, JSON.stringify(data));
                    resolve();
                },
                err => {
                    console.log(err);
                }
            );
        });
    } catch (error) {
        console.error("Error getAzureStorageSASToken:", error);
    }
};

export const setClientProfileImage = async (profileImageName, clientId) => {
    try {
        return await new Promise(function (resolve, reject) {
            API.setClientProfileImage(profileImageName, clientId).then(
                data => {
                    resolve();
                },
                err => {
                    console.log(err);
                }
            );
        });
    } catch (error) {
        console.error("Error setClientProfileImage:", error);
    }
};

export const setJournalImage = async (imagesName, clientId, journalId) => {
    try {
        return await new Promise(function (resolve, reject) {
            API.setJournalImage(imagesName, clientId, journalId).then(
                data => {
                    resolve();
                },
                err => {
                    console.log(err);
                }
            );
        });
    } catch (error) {
        console.error("Error setJournalImage:", error);
    }
};

export const setGoogleUploadForClientProfile = async (profileImageName, clientId) => {
    try {
        return await new Promise(function (resolve, reject) {
            API.setGoogleUploadForClientProfile(profileImageName, clientId).then(
                data => {
                    resolve();
                },
                err => {
                    console.log(err);
                }
            );
        });
    } catch (error) {
        console.error("Error setGoogleUploadForClientProfile:", error);
    }
};

export const setGoogleUploadForJournalImage = async (imagesName, clientId, journalId) => {
    try {
        return await new Promise(function (resolve, reject) {
            API.setGoogleUploadForJournalImage(imagesName, clientId, journalId).then(
                data => {
                    resolve();
                },
                err => {
                    console.log(err);
                }
            );
        });
    } catch (error) {
        console.error("Error setGoogleUploadForJournalImage:", error);
    }
};
